import { useSelector } from 'react-redux'
import React, { useEffect } from 'react'
import { DateTime } from 'luxon';
import $ from 'jquery'

import { 
    auditCaseStudyMetrics, 
    auditMetricsForCompare, 
    auditMetricGroups, 
    smbAuditMetricGroups,
    standardAuditMetricGroups,
    getColorByComparison, 
    auditMetricsDictionary, 
    StatusIndicator, 
    smbAuditCaseStudyMetrics,
    LATEST_AUDIT_VERSION,
    DEFAULT_AUDIT_VARIANCE,
    ecommerceAuditMetricGroups,
    ecommerceAuditCaseStudyMetrics,
    standardAuditCaseStudyMetrics,
    franDevCaseStudyV3,
    StatusIndicatorV3,
    franDevMetricGroups,
    ecomAuditCaseStudyMetrics,
    newEcomAuditMetricGroups,
    auditVariance
} from '../../../utils/Audits'

import scoresImg from "../../../../assets/images/scores.png"
import topThreeProds from "../../../../assets/images/alert-icons/top-3-products.png"
import auditBk from "../../../../assets/images/analytics-bg.jpg"

import Image from '../../Layout/Common/Image'
import ApexChart from '../../ApexCharts/ApexChart';

const DEFAULT_PROPS = {
    audit: null,
    showImages: true,
    prevMetrics: null,
    site: null,
    version: LATEST_AUDIT_VERSION,
    insights: {}
}

function AuditCard({audit, prevMetrics, showImages, site, version, insights}){
    const model = useSelector(state => state.site.model)
    const useDarkMode = useSelector(state => state.session.useDarkMode)

    useEffect(() => {
        $('[data-toggle="tooltip"]').tooltip()
    }, [])

    if(!site){
        site = model.all.find(s => s.type === "SITE" && s.siteId === audit.siteId)
    }

    const titleDictionary = {
        "frandev": "FranDev Performance",
        "smbstats": "Standard",
        "veteranstats": "Veteran Stats",
        "ecommercestats": "Ecommerce",
        "ecommerce": "Ecommerce",
        "standard": "Standard",
        "frandevNew": "FranDev Performance"
    }

    if(audit === null){
        return <div class="card profile-card-audit">
            <div class="background-block">
                <Image src={auditBk} alt="Audit Card Background" class="background"/>
            </div>
            <div class="profile-thumb-block">
                <img external src={`${import.meta.env.MODE==="development" ? "http://localhost:3005" : "https://api.internetstrategylabs.com"}/admin/gauge/0`} alt="profile-image" class="profile" style={{zoom: "140%"}} />
            </div>
            <div class="card-content">
                <h2>Audit Not Available</h2>
            </div>
        </div>
    }

    const metricColors = Object.keys(audit.metrics).reduce((prev, curr, idx, arr) => {
        if(auditMetricsForCompare[curr] && 
            (auditMetricsForCompare[curr].typesDisabled === undefined || 
                !auditMetricsForCompare[curr].typesDisabled.includes(audit.type))) {

            const [color, score] = getColorByComparison(audit.metrics[curr], auditCaseStudyMetrics[curr], auditMetricsForCompare[curr].opposite)
            if((Array.isArray(auditMetricsForCompare[curr].excludeFromScore) && 
                !auditMetricsForCompare[curr].excludeFromScore.includes(audit.type)) || 
                !auditMetricsForCompare[curr].excludeFromScore || 
                auditMetricsForCompare[curr].excludeFromScore === undefined) {
                prev.score += score
                prev.scoreDivide += 1
            }
            
            prev[curr] = color
        }
        
        return prev
    }, {
        score: 0,
        scoreDivide: 0
    })

    let auditScorePercent = parseInt(Math.round(metricColors.score / metricColors.scoreDivide * 100))
    let baseScorePercent = 0

    let metricGroup = auditMetricGroups
    let metricCaseStudyCompare = standardAuditCaseStudyMetrics

    let series = []
    let labels = []

    let ecomSeries = []
    let ecomLabels = []

    const colorTypes = {
        smbstats: "green",
        veteranstats: "#204592",
        ecommercestats: "#4b0213",
        ecommerce: "#4b0213",
        standard: "green"
    }

    const color = audit.meta && audit.meta.colorHex ? audit.meta.colorHex : colorTypes[audit.type] ?  colorTypes[audit.type] :"#f05323"

    const auditStartDate = site?.attr?.auditBaseline?.startDate ?? DateTime.local().minus({days: 1, months: 1}).toISODate()
    const auditEndDate = site?.attr?.auditBaseline?.endDate ?? DateTime.local().minus({days: 1}).toISODate()

    if(audit.type === "smbstats" || audit.type === "veteranstats" || audit.type === "ecommercestats"){
        metricGroup = smbAuditMetricGroups
        metricCaseStudyCompare = smbAuditCaseStudyMetrics

        if(audit.type === "ecommercestats"){
            metricGroup = ecommerceAuditMetricGroups
            metricCaseStudyCompare = {
                ...ecommerceAuditCaseStudyMetrics,
                transactions: prevMetrics?.transactions ?? 0
            }

            if(audit.metrics.topProducts){
                ecomLabels = audit.metrics.topProducts.map(p => p.name)
                ecomSeries = audit.metrics.topProducts.map(p => +p.revenue.toFixed(2))
            }
        }

        const visits = audit.metrics.gmbWebsiteViews
        const calls = audit.metrics.gmbPhone
        const directions = audit.metrics.gmbDirections

        if(visits && calls && directions){

            const dictionary = {
                [visits.toString()]: "Website visits",
                [calls.toString()]: "Phone calls",
                [directions.toString()]: "Direction requests",
            }
            
            series = [parseInt(visits), parseInt(calls), parseInt(directions)].sort((a,b) => b - a)
            labels = series.map(s => dictionary[s.toString()])
        }

    } else if(audit.type === "standard") {
        metricGroup = standardAuditMetricGroups
        metricCaseStudyCompare = standardAuditCaseStudyMetrics
    } else if(audit.type === "frandevNew" && version === LATEST_AUDIT_VERSION){
        metricGroup = franDevMetricGroups
        metricCaseStudyCompare = franDevCaseStudyV3
    } else if(audit.type === "ecommerce"){
        metricGroup = newEcomAuditMetricGroups
        metricCaseStudyCompare = ecomAuditCaseStudyMetrics
    }

    // Hack to get rid of undefined
    metricGroup = metricGroup.filter(g => g !== undefined)

    const statusCompare = Object.keys(audit.metrics).reduce((prev, curr, idx, arr) => {
        if(auditMetricsForCompare[curr] && 
            (auditMetricsForCompare[curr].typesDisabled === undefined || 
                !auditMetricsForCompare[curr].typesDisabled.includes(audit.type))) {
            
            let [color, _, diff] = getColorByComparison(
                auditMetricsForCompare[curr].comparisonValue ? auditMetricsForCompare[curr].comparisonValue(audit.metrics[curr]) : audit.metrics[curr], 
                auditMetricsForCompare[curr].comparisonValue ? auditMetricsForCompare[curr].comparisonValue(prevMetrics ? (prevMetrics[curr] ?? 0) : 0) : prevMetrics ? (prevMetrics[curr] ?? 0) : 0, 
                auditMetricsForCompare[curr].opposite
                )            
            if(!auditMetricsForCompare[curr].excludeFromScore ||
                (Array.isArray(auditMetricsForCompare[curr].excludeFromScore) && 
                !auditMetricsForCompare[curr].excludeFromScore.includes(audit.type))) {
                let [c, s, d] = getColorByComparison(audit.metrics[curr], metricCaseStudyCompare[curr], auditMetricsForCompare[curr].opposite)
                prev[curr] = <strong style={{color: c}}>
                    <StatusIndicator color={c} version={version} opposite={auditMetricsForCompare[curr].opposite} /> <span> Baseline of {metricCaseStudyCompare[curr] == 0 ? "+ Growth" : auditMetricsDictionary[curr].modifier ? auditMetricsDictionary[curr].modifier(metricCaseStudyCompare[curr]) : metricCaseStudyCompare[curr]}{metricCaseStudyCompare[curr] !== 0 ? auditMetricsDictionary[curr].suffix ?? "" : ""}</span>
                </strong>
                
                prev.score += s
                prev.scoreDivide += 1
            } else {
                if(prevMetrics === DEFAULT_PROPS.prevMetrics) {
                    prev[curr] = <></>
                } else if(Array.isArray(auditMetricsForCompare[curr].excludeFromScore) && 
                    auditMetricsForCompare[curr].excludeFromScore.includes(audit.type)){
                    prev[curr] = <div style={{color}}>
                        <StatusIndicator color={color} version={version} opposite={auditMetricsForCompare[curr].opposite} /> {diff < 10 ? diff.toFixed(1) : diff.toFixed(0)}%
                    </div>
                } else if(!Array.isArray(auditMetricsForCompare[curr].excludeFromScore) && auditMetricsForCompare[curr].excludeFromScore) {
                    prev[curr] = <div style={{color}}>
                        <StatusIndicator color={color} version={version} opposite={auditMetricsForCompare[curr].opposite} /> {diff < 10 ? diff.toFixed(1) : diff.toFixed(0)}%
                    </div>
                } 
            }
        }
        
        return prev
    }, {
        score: 0,
        scoreDivide: 0
    })

    const statusCompareV3 = (metricsGrouping="metrics", isBaseline=true) => Object.keys(audit.metrics).reduce((prev, curr, idx, arr) => {
        
        if(auditMetricsForCompare[curr] && 
            (auditMetricsForCompare[curr].typesDisabled === undefined || 
                !auditMetricsForCompare[curr].typesDisabled.includes(audit.type))) {
                        
            if(!auditMetricsForCompare[curr].excludeFromScore ||
                (Array.isArray(auditMetricsForCompare[curr].excludeFromScore) && 
                !auditMetricsForCompare[curr].excludeFromScore.includes(audit.type))) {
                
                
                let [c, s, d] = getColorByComparison(
                    audit[metricsGrouping] ? (audit[metricsGrouping][curr] ?? 0) : 0, 
                    isBaseline ? metricCaseStudyCompare[curr] : audit.metrics[curr], 
                    auditMetricsForCompare[curr].opposite,
                    isBaseline ? 0 : auditVariance[curr] ? auditVariance[curr] : 0,
                    auditMetricsForCompare[curr].scoreToBaselineOverride ?? false
                )
                
                prev[curr] = c === "black" ? <strong className="pl-1" style={{color: c, display:"inline-block"}}>
                        <span style={{fontSize: "8pt"}}><i class="fas fa-minus-circle"></i></span>
                    </strong> : <strong className="pl-1" style={{color: c, display:"inline-block"}}>
                    <StatusIndicatorV3 color={c} version={version} opposite={auditMetricsForCompare[curr].opposite} /> {!auditMetricsForCompare[curr].scoreToBaselineOverride && (<span className="d-none d-sm-inline-block d-md-inline-block d-lg-inline-block d-xl-inline-block" 
                        style={{fontSize: "8pt", color: c}}>
                        {d.toFixed(0)}%
                    </span>)} {!auditMetricsForCompare[curr].scoreToBaselineOverride && (<span className="d-inline-block d-sm-none d-md-none d-lg-none d-xl-none" style={{fontSize: "8pt", color: c}}>
                        {d.toFixed(0)}%
                    </span>)}
                </strong>
                
                prev.score += s
                prev.scoreDivide += 1
            }
        }
        
        return prev
    }, {
        score: 0,
        scoreDivide: 0
    })

    const statusCompareV3MonthAvg = Object.keys(audit.metrics).reduce((prev, curr, idx, arr) => {
        if(auditMetricsForCompare[curr] && 
            (auditMetricsForCompare[curr].typesDisabled === undefined || 
                !auditMetricsForCompare[curr].typesDisabled.includes(audit.type))) {
                        
            if(!auditMetricsForCompare[curr].excludeFromScore ||
                (Array.isArray(auditMetricsForCompare[curr].excludeFromScore) && 
                !auditMetricsForCompare[curr].excludeFromScore.includes(audit.type))) {
                let overrideShow = true
                
                let [c, s, d] = getColorByComparison(audit.monthlyAvgMetrics ? (audit.monthlyAvgMetrics[curr] ?? 0) : 0, audit.metrics[curr], auditMetricsForCompare[curr].opposite)            
                if(metricCaseStudyCompare[curr]){
                    [c, s, d] = getColorByComparison(audit.monthlyAvgMetrics ? (audit.monthlyAvgMetrics[curr] ?? 0) : 0, metricCaseStudyCompare[curr], auditMetricsForCompare[curr].opposite)
                    if((!audit.monthlyAvgMetrics || !audit.monthlyAvgMetrics[curr]) && audit.metrics[curr]){
                        overrideShow = false
                    }
                }

                
                prev[curr] = overrideShow ? <strong style={{color: c}}>
                    <StatusIndicatorV3 color={c} version={version} opposite={auditMetricsForCompare[curr].opposite} /><span className="d-none d-sm-inline d-md-inline d-lg-inline d-xl-inline" style={{fontSize: "10pt", color: c}}>
                        {d.toFixed(0)}%
                    </span> <span className="d-block d-sm-none d-md-none d-lg-none d-xl-none" style={{fontSize: "0.8em", color: c}}>
                        {d.toFixed(0)}%
                    </span>
                </strong> : ""
                
                prev.score += s
                prev.scoreDivide += 1
            }
        }
        
        return prev
    }, {
        score: 0,
        scoreDivide: 0
    })

    if(version === LATEST_AUDIT_VERSION){
        auditScorePercent = parseInt(Math.round(statusCompareV3("prevMetrics", false).score / statusCompareV3("prevMetrics", false).scoreDivide * 100))
        baseScorePercent = parseInt(Math.round(statusCompareV3().score / statusCompareV3().scoreDivide * 100))
    } else if(version === 2){
        auditScorePercent = parseInt(Math.round(statusCompare.score / statusCompare.scoreDivide * 100))
    }

    const V1 = () => metricGroup.map(group => group.disableIfUndefined &&
        audit.metrics[group.metrics[0]] === undefined ? null :<>
        {showImages && <div className="row">
            {group.image()}
        </div>}
        <div className="row">
            <h4 className="mx-auto d-block">{group.title}</h4>
        </div>
        <div className="row">
            <div className="col-3 text-left" style={{
                color,
                fontWeight: "bold",
                fontSize: "10pt"
            }}>Metric</div>
            <div className="col-3 text-right" style={{
                color,
                fontWeight: "bold",
                fontSize: "10pt"
            }}>{audit.yearMonth ? DateTime.fromFormat(audit.yearMonth.toString(), "yyyyMM").toFormat("LLL yyyy") : "" }</div>
            <div className="col-3 text-right" style={{
                color,
                fontWeight: "bold",
                fontSize: "10pt"
            }}>{audit.type === "smbstats" ?  "Individual Standard" :"Case Study"}</div>
            <div className="col-3 text-left" style={{
                color,
                fontWeight: "bold",
                fontSize: "10pt"
            }}>Pass/Fail</div>
        </div>
        {group.metrics.map((metric, key) => metric.disableIfUndefined && audit.metrics[metric] === undefined ? null : <div className="row">
            <div className="col-3 text-left">
                {auditMetricsDictionary[metric].title}
            </div>
            <div className="col-3 text-right" style={{color: auditMetricsForCompare[metric] && 
                (auditMetricsForCompare[metric].typesDisabled === undefined || 
                !auditMetricsForCompare[metric].typesDisabled.includes(audit.type)) && metricColors[metric] ? metricColors[metric] : "black"}}>
                {auditMetricsDictionary[metric].prefix ?? ""}{auditMetricsDictionary[metric].modifier ? auditMetricsDictionary[metric].modifier(audit.metrics[metric]) : audit.metrics[metric]}{auditMetricsDictionary[metric].suffix ?? ""}
            </div>
            {auditMetricsForCompare[metric] && 
                (auditMetricsForCompare[metric].typesDisabled === undefined || 
                !auditMetricsForCompare[metric].typesDisabled.includes(audit.type)) && 
                auditMetricsForCompare[metric].caseStudyOverride ? <div className="col-3 text-right">
                {auditMetricsForCompare[metric].caseStudyOverride}
            </div> : auditMetricsForCompare[metric] && auditMetricsForCompare[metric].typesDisabled !== undefined &&
                auditMetricsForCompare[metric].typesDisabled.includes(audit.type) ? <div className="col-3 text-right"></div> :
            <div className="col-3 text-right">
                {auditMetricsDictionary[metric] && auditCaseStudyMetrics[metric] > 0 ? (auditMetricsDictionary[metric].prefix ?? "") : ""}
                {!auditCaseStudyMetrics[metric] ? "" : auditMetricsDictionary[metric].modifier ? auditMetricsDictionary[metric].modifier(auditCaseStudyMetrics[metric]) : auditCaseStudyMetrics[metric]}
                {auditMetricsDictionary[metric] && auditCaseStudyMetrics[metric] > 0 ? (auditMetricsDictionary[metric].suffix ?? "") : ""}
            </div>}
            <div className="col-3 text-left">
                {auditMetricsForCompare[metric] && auditMetricsForCompare[metric].typesDisabled !== undefined && auditMetricsForCompare[metric].typesDisabled.includes(audit.type) ? "" : metricColors[metric] ? !auditMetricsForCompare[metric].excludeFromScore ? <StatusIndicator color={metricColors[metric]} /> : <i class="fas fa-asterisk"></i>: ""}
            </div>
        
        </div>)}
        <br />
    </>)

    const V2 = () => {
        return metricGroup.map((group, key) => group.disableIfUndefined &&
            audit.metrics[group.metrics[0]] === undefined ? null :<>
            {showImages && <div className="row">
                {group.image()}
            </div>}
            <h4 className="mx-auto d-block">{group.title}</h4>
            <i className="text-center d-block">Stats compared to previous month</i>
            <br />
            {group.metrics.map(metric => metric.disableIfUndefined && audit.metrics[metric] === undefined ? null : <div className="row">
                <div className="col-sm-12 text-center">
                    {auditMetricsDictionary[metric].title}
                </div>
                <div className="col-sm-12 text-center">
                    {auditMetricsDictionary[metric].prefix ?? ""}{auditMetricsDictionary[metric].modifier ? auditMetricsDictionary[metric].modifier(audit.metrics[metric]) : audit.metrics[metric]}{auditMetricsDictionary[metric].suffix ?? ""}
                </div>
                <div className="col-sm-12 text-center" style={{marginBottom: "5px"}}>
                    {statusCompare[metric]}
                </div>
            </div>)}
            {audit.type === "ecommercestats" && key === 0 && 
                <>
                    {showImages && <div className="row">
                        <Image width={84} height={64} className="mx-auto d-block" src={topThreeProds} />
                    </div>}
                    <h4 className="mx-auto d-block">Top Three Products</h4>
                    <ApexChart
                        options={{
                            chart: {
                                width:"400",
                                height:"200",
                                type:"pie"
                            },  
                            labels: ecomLabels                      
                        }}
                        series= {ecomSeries}
                        type="pie"
                        width="400"
                    />
                </>
            }
            <br />
        </>)
    }


    const V3 = () => {
        if(!audit.metrics) return ""
        return metricGroup.map(group => group.disableIfUndefined &&
            group.metrics.reduce((prev, curr) => {
                if(audit.metrics[curr] !== undefined){
                    prev = true;
                } 
                return prev
            }, false) === false ? null :<>
            {showImages && <div className="row">
                {group.image()}
            </div>}
            <div className="row">
                <h3 className="mx-auto d-block font-weight-bold">{group.title}</h3>
            </div>
            <div className="row bg-light-grey capitalize">
                <div className="col-xl-4 col-lg-2 col-md-2 col-sm-2 col-2 text-left" style={{
                    fontWeight: "bold",
                    fontSize: "12pt"
                }}>
                    <div className="d-xl-block d-lg-block d-md-block d-sm-block d-none">
                        METRIC
                    </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-4 col-sm-4 col-4 text-right" style={{
                    fontWeight: "bold",
                    fontSize: "12pt"
                }}>
                    <div className="d-xl-block d-lg-block d-md-block d-sm-block d-none">
                        BASELINE <div className="d-xl-block d-lg-block d-md-none d-sm-none d-none"
                            data-toggle="tooltip" 
                            data-placement="top"
                            title={`${DateTime.fromISO(auditStartDate).toFormat("LLL dd")}-${DateTime.fromISO(auditEndDate).toFormat("LLL dd, yyyy")}`}>
                            {DateTime.fromISO(auditStartDate).toFormat("LLL dd")}-{DateTime.fromISO(auditEndDate).toFormat("LLL dd")}
                        </div>
                    </div>
                    <div className="d-xl-none d-lg-none d-md-none d-sm-none d-block h6 font-weight-bold"
                        data-toggle="tooltip" 
                        data-placement="top"
                        title={`${DateTime.fromISO(auditStartDate).toFormat("LLL dd")}-${DateTime.fromISO(auditEndDate).toFormat("LLL dd, yyyy")}`}>
                        BASE<br />LINE
                    </div>
                </div>
                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-3 col-3 text-right" style={{
                    fontWeight: "bold",
                    fontSize: "12pt"
                }}>
                    <div className="d-xl-block d-lg-block d-md-block d-sm-block d-none">
                        {audit.yearMonth ? DateTime.fromFormat(audit.yearMonth.toString(), "yyyyMM").toFormat("LLL").toUpperCase() : ""}<br />
                        {audit.yearMonth ? DateTime.fromFormat(audit.yearMonth.toString(), "yyyyMM").toFormat("yyyy").toUpperCase() : "" }
                    </div>
                    <div className="d-xl-none d-lg-none d-md-none d-sm-none d-block h6 font-weight-bold">
                        {audit.yearMonth ? DateTime.fromFormat(audit.yearMonth.toString(), "yyyyMM").toFormat("LLL").toUpperCase() : ""}<br />
                        {audit.yearMonth ? DateTime.fromFormat(audit.yearMonth.toString(), "yyyyMM").toFormat("yyyy").toUpperCase() : "" }
                    </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 text-right" style={{
                    fontWeight: "bold",
                    fontSize: "12pt"
                }}>
                    <div className="d-xl-block d-lg-block d-md-none d-sm-none d-none">
                        12 MONTH<br /> AVERAGE &#8224;
                    </div>
                    <div className="d-xl-none d-lg-none d-md-block d-sm-block d-none">
                        MTH<br /> AVG &#8224;
                    </div>
                    <div className="d-xl-none d-lg-none d-md-none d-sm-none d-block h6 font-weight-bold">
                        MTH<br /> AVG &#8224;
                    </div>
                </div>
            </div>
            <div className="mb-4">
                {group.metrics.map((metric, key) => {
                    return auditMetricsForCompare[metric].disableIfUndefined && audit.metrics[metric] === undefined ? null : <div className={`row pt-2`} style={key % 2 === 1 ? {backgroundColor: useDarkMode ? "#262d33" : "rgb(243 243 243)"} : {}}>
                        <div className="col-xl-4 col-lg-2 col-md-2 col-sm-2 col-2 text-left h4 font-weight-bold">
                            <div className="d-xl-block d-lg-none d-md-none d-sm-none d-none">{auditMetricsDictionary[metric].title}</div>
                            <div className="d-lg-block d-xl-none d-md-block d-sm-block d-none" dangerouslySetInnerHTML={{__html: auditMetricsDictionary[metric].titleAbbrev}}></div>
                            <div className="d-lg-none d-xl-none d-md-none d-sm-none d-block h6 font-weight-bold" dangerouslySetInnerHTML={{__html: auditMetricsDictionary[metric].titleAbbrev}}></div>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-4 col-sm-4 col-4 text-right h4 mt-auto font-weight-bold" style={{color: "black"}}>
                            <div id={"baseline-"+auditMetricsDictionary[metric].title.replaceAll(" ", "-")} className="d-xl-inline-block d-lg-inline-block d-md-inline-block d-sm-inline-block d-none">
                                {auditMetricsDictionary[metric].prefix ?? ""}{auditMetricsDictionary[metric].modifier ? auditMetricsDictionary[metric].modifier(audit.metrics[metric]) : audit.metrics[metric]}{auditMetricsDictionary[metric].suffix ?? ""}
                            </div>
                            <div id={auditMetricsDictionary[metric].title.replaceAll(" ", "-")} className="d-xl-none d-lg-none d-md-none d-sm-none d-inline-block h6 font-weight-bold">
                                {auditMetricsDictionary[metric].prefix ?? ""}{auditMetricsDictionary[metric].modifier ? auditMetricsDictionary[metric].modifier(audit.metrics[metric]) : audit.metrics[metric]}{auditMetricsDictionary[metric].suffix ?? ""}
                            </div>
                            {statusCompareV3()[metric]}{(metricCaseStudyCompare[metric] || metricCaseStudyCompare[metric] >= 0) ? <span className="float-right"
                                style={{fontSize: "12px"}}
                                data-toggle="tooltip" 
                                data-placement="top" 
                                title={`When comparing to a baseline of ${auditMetricsDictionary[metric] ? (auditMetricsDictionary[metric].prefix ?? "") : ""}${auditMetricsForCompare[metric].caseStudyOverride ? auditMetricsForCompare[metric].caseStudyOverride : auditMetricsDictionary[metric].modifier ? auditMetricsDictionary[metric].modifier(metricCaseStudyCompare[metric]) : metricCaseStudyCompare[metric]}${auditMetricsDictionary[metric] ? (auditMetricsDictionary[metric].suffix ?? "") : ""}`}>
                                    *
                                </span> : ""}
                        </div>
                        {auditMetricsForCompare[metric] && auditMetricsForCompare[metric].typesDisabled !== undefined &&
                            auditMetricsForCompare[metric].typesDisabled.includes(audit.type) ? <div className="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 col-sm-2 text-left h4 mt-auto font-weight-bold">
                            </div> :
                        <div className="col-xl-2 col-lg-3 col-md-3 col-sm-3 col-3 text-right h4 mt-auto font-weight-bold">
                            <div className="d-xl-inline-block d-lg-inline-block d-md-inline-block d-sm-inline-block d-none">                            
                                {auditMetricsDictionary[metric] ? (auditMetricsDictionary[metric].prefix ?? "") : ""}
                                {auditMetricsDictionary[metric].modifier ? auditMetricsDictionary[metric].modifier(audit.prevMetrics[metric]) : (audit.prevMetrics[metric])}
                                {auditMetricsDictionary[metric] ? (auditMetricsDictionary[metric].suffix ?? "") : ""}
                            </div>        
                            <div className="d-xl-none d-lg-none d-md-none d-sm-none d-inline-block h6 font-weight-bold">                  
                                {auditMetricsDictionary[metric] ? (auditMetricsDictionary[metric].prefix ?? "") : ""}
                                {auditMetricsDictionary[metric].modifier ? auditMetricsDictionary[metric].modifier(audit.prevMetrics[metric]) : (audit.prevMetrics[metric])}
                                {auditMetricsDictionary[metric] ? (auditMetricsDictionary[metric].suffix ?? "") : ""}
                            </div>
                            {statusCompareV3("prevMetrics", false)[metric]}
                        </div>}
                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 text-right h4 mt-auto font-weight-bold">
                            <div className="d-xl-inline-block d-lg-inline-block d-md-inline-block d-sm-inline-block d-none">
                                {audit.monthlyAvgMetrics[metric] === undefined && metricCaseStudyCompare[metric] ? "N/A" : auditMetricsForCompare[metric].typesDisabled !== undefined && auditMetricsForCompare[metric].typesDisabled.includes(audit.type) ? "" : ((auditMetricsDictionary[metric] ? (auditMetricsDictionary[metric].prefix ?? "") : "") + 
                                (auditMetricsDictionary[metric].modifier ? auditMetricsDictionary[metric].modifier(audit.monthlyAvgMetrics[metric]) : audit.monthlyAvgMetrics[metric]) + 
                                (auditMetricsDictionary[metric] ? (auditMetricsDictionary[metric].suffix ?? "") : "")) }
                            </div>
                            <div className="d-xl-none d-lg-none d-md-none d-sm-none d-block h6 font-weight-bold">
                                {audit.monthlyAvgMetrics[metric] === undefined && metricCaseStudyCompare[metric] ? "N/A" : auditMetricsForCompare[metric].typesDisabled !== undefined && auditMetricsForCompare[metric].typesDisabled.includes(audit.type) ? "" : ((auditMetricsDictionary[metric] ? (auditMetricsDictionary[metric].prefix ?? "") : "") + 
                                (auditMetricsDictionary[metric].modifier ? auditMetricsDictionary[metric].modifier(audit.monthlyAvgMetrics[metric]) : audit.monthlyAvgMetrics[metric]) + 
                                (auditMetricsDictionary[metric] ? (auditMetricsDictionary[metric].suffix ?? "") : "")) }
                            </div>
                            {statusCompareV3("monthlyAvgMetrics", false)[metric]}
                        </div>
                    </div>
                })}
            </div>
            <br />
        </>)
    }
    
    return <div class="card profile-card-audit">
        {version !== LATEST_AUDIT_VERSION && <div class="background-block">
            <Image src={auditBk} alt="Audit Card Background" class="background"/>
        </div>}
        
        {version === LATEST_AUDIT_VERSION ? <div className="d-flex justify-content-center align-items-end p-5" style={{background: `url(${auditBk})`, backgroundSize: "cover", backgroundPosition: "50% 100%"}}>
            <div className="mr-2">
                <img 
                    title={`Baseline score of ${baseScorePercent}% (${DateTime.fromISO(auditStartDate).toFormat("LLL dd")}-${DateTime.fromISO(auditEndDate).toFormat("LLL dd, yyyy")})`} 
                    src={`${import.meta.env.MODE==="development" ? "http://localhost:3005" : "https://api.internetstrategylabs.com"}/admin/gauge/${baseScorePercent}${useDarkMode ? "?darkMode=1" : ""}`} 
                    alt="profile-image" className="score" style={{zoom: "90%"}} />
                <h4 className="font-weight-bold mt-2 text-white text-shadow">
                    Baseline<br />
                    {DateTime.fromISO(auditStartDate).toFormat("LLL dd")}-{DateTime.fromISO(auditEndDate).toFormat("LLL dd")}
                </h4>
            </div>
            <div>
                <img 
                    title={`${DateTime.fromFormat(audit.yearMonth.toString(), "yyyyMM").toFormat("LLL yyyy")} Audit score of ${auditScorePercent}%`}
                    src={`${import.meta.env.MODE==="development" ? "http://localhost:3005" : "https://api.internetstrategylabs.com"}/admin/gauge/${auditScorePercent}${useDarkMode ? "?darkMode=1" : ""}`} 
                    alt="profile-image" class="score" style={{zoom: "130%"}} />
                <h4 className="font-weight-bold mt-2 text-white text-shadow">
                    {DateTime.fromFormat(audit.yearMonth.toString(), "yyyyMM").toFormat("LLL")}
                    <br />
                    {DateTime.fromFormat(audit.yearMonth.toString(), "yyyyMM").toFormat("yyyy")}
                </h4>
            </div>
        </div> : <div class="profile-thumb-block">
            <img title={`${DateTime.fromFormat(audit.yearMonth.toString(), "yyyyMM").toFormat("LLL yyyy")} Audit score of ${auditScorePercent}%`}
                src={`${import.meta.env.MODE==="development" ? "http://localhost:3005" : "https://api.internetstrategylabs.com"}/admin/gauge/${auditScorePercent}${useDarkMode ? "?darkMode=1" : ""}`} alt="profile-image" class="profile" style={{zoom: "140%"}} />
            {/* <img src={`${import.meta.env.MODE==="development" ? "http://localhost:3005" : "https://api.internetstrategylabs.com"}/admin/gauge/${baseScorePercent}${useDarkMode ? "?darkMode=1" : ""}`} alt="profile-image" class="profile" style={{zoom: "95%", left: "70%"}} /> */}
        </div>}
        <div class="card-content">
            <Image className="mx-auto d-block" src={scoresImg} />
            <h2 id="auditTitle" style={{
                color,
                filter: useDarkMode ? "brightness(2.5)" : ""
            }}>
                {titleDictionary[audit.type]} Audit<small>Period: {audit.yearMonth ? DateTime.fromFormat(audit.yearMonth.toString(), "yyyyMM").toFormat("LLL yyyy") : "" }</small>
            </h2>
            {version === LATEST_AUDIT_VERSION && <h5>
                &#8224;: Based on available averages up to 12 months<br />
                * : Comparison is based on a case study metric (click/hover for more info)
            </h5>}
            <br />
            {audit.note ? <div className="row" id="auditNote">
                <div className="col-12 text-left" dangerouslySetInnerHTML={{__html: audit.note}}></div>
            </div>: null}
            {audit.yearMonth >= 202307 && <div id="insights" className="text-left">
                {insights?.items?.map(i => <div>
                    <img src={i.icon} style={{ width: "40px", height: "40px" }} /> <strong style={{fontSize: "16px"}}>{i.title}</strong>
                    <p dangerouslySetInnerHTML={{__html: i.issue}}></p>
	                {i.icons && <p>{i.icons?.map(icon => <img title={icon.title} src={icon.icon} style={{width:"24px",height:"24px", marginRight: "5px"}} />)}</p>}
                </div>)}
            </div>}
            {version === 1 ? V1() : version === 2 ? V2() : version === LATEST_AUDIT_VERSION ? V3() : null}
            {(audit.type === "smbstats" || audit.type === "veteranstats" || audit.type === "ecommercestats") && 
                <ApexChart
                    options={{
                        chart: {
                            width:"400",
                            height:"200",
                            type:"pie"
                        },  
                        labels: labels                      
                    }}
                    series= {series}
                    type="pie"
                    width="400"
                />
                }
        </div>
    </div>
}

AuditCard.defaultProps = DEFAULT_PROPS

export default AuditCard
